export type ValidationErrorDataType = {
  id: string;
  modalTitle?: string;
  errorDescription?: string;
  tokenValues?: Record<string, string>;
  bodyDescription?: string;
};

/**
 * Error object returned from Validator API does not contain
 * the translation required to show in the UI (modal title, error description, body description).
 * This object maps the error id to the translation keys.
 */
export const validationErrorsMessages: Record<string, ValidationErrorDataType> = {
  PasswordValidator: {
    id: 'PasswordValidator',
    modalTitle: 'validations.PasswordValidator.error-modal-title',
    errorDescription: 'validations.PasswordValidator.error-description',
    bodyDescription: 'validations.PasswordValidator.error-body-description',
  },
  CorruptValidator: {
    id: 'CorruptValidator',
    modalTitle: 'validations.CorruptValidator.error-modal-title',
    errorDescription: 'validations.CorruptValidator.error-description',
    bodyDescription: 'validations.CorruptValidator.error-body-description',
  },
  PageSizeValidator: {
    id: 'PageSizeValidator',
    modalTitle: 'validations.PageSizeValidator.error-modal-title',
    errorDescription: 'validations.PageSizeValidator.error-description',
    bodyDescription: 'validations.PageSizeValidator.error-body-description',
  },
  PageCountValidator: {
    id: 'PageCountValidator',
    modalTitle: 'validations.PageCountValidator.error-modal-title',
    errorDescription: 'validations.PageCountValidator.error-description',
    bodyDescription: 'validations.PageCountValidator.error-body-description',
  },
  PageOrientationValidator: {
    id: 'PageOrientationValidator',
    modalTitle: 'validations.PageOrientationValidator.error-modal-title',
    errorDescription: 'validations.PageOrientationValidator.error-description',
    bodyDescription: 'validations.PageOrientationValidator.error-body-description',
  },
  UnEmbeddedFontsValidator: {
    id: 'UnEmbeddedFontsValidator',
    modalTitle: 'validations.UnEmbeddedFontsValidator.error-modal-title',
    errorDescription: 'validations.UnEmbeddedFontsValidator.error-description',
    bodyDescription: 'validations.UnEmbeddedFontsValidator.error-body-description',
  },
  ImageResolutionValidator: {
    id: 'ImageResolutionValidator',
    modalTitle: 'validations.ImageResolutionValidator.error-modal-title',
    errorDescription: 'validations.ImageResolutionValidator.error-description',
    bodyDescription: 'validations.ImageResolutionValidator.error-body-description',
  },
  EncryptedValidator: {
    id: 'EncryptedValidator',
    modalTitle: 'validations.EncryptedValidator.error-modal-title',
    errorDescription: 'validations.EncryptedValidator.error-description',
    bodyDescription: 'validations.EncryptedValidator.error-body-description',
  },
  TemplateMismatchValidator: {
    id: 'TemplateMismatchValidator',
    modalTitle: 'validations.TemplateMismatchValidator.error-modal-title',
    errorDescription: 'validations.TemplateMismatchValidator.error-description',
    bodyDescription: 'validations.TemplateMismatchValidator.bodyDescription',
  },
};
